import React from 'react'
import {
  RESPONSIVE_BREAKPOINT_VERSIONS,
  useResponsiveBreakpointsVersion
} from 'contexts/ResponsiveBreakpointsContext'
import { BannerContainer } from './Banner.styles'

export default function Banner({ children }) {
  const responsiveBreakpointsVersion = useResponsiveBreakpointsVersion()
  const responsiveBreakpointsV2 =
    responsiveBreakpointsVersion === RESPONSIVE_BREAKPOINT_VERSIONS.V2

  return (
    <BannerContainer
      $responsiveBreakpointsV2={responsiveBreakpointsV2}
      className="flex-none -bottom-1 w-full z-30"
    >
      {children}
    </BannerContainer>
  )
}
